var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "nk-block-head nk-block-head-sm" }, [
      _c("div", { staticClass: "nk-block-between" }, [
        _c("div", { staticClass: "nk-block-head-content" }, [
          _c("h3", { staticClass: "nk-block-title page-title" }, [
            _vm._v(_vm._s(_vm.trans("configuration.configuration"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "nk-block-des text-soft" }, [
            _c("p", [_vm._v(_vm._s(_vm.trans("general.scheduled_job")))]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "admin-config-layout admin-linear-page" },
      [
        _c("configuration-sidebar", { attrs: { menu: "scheduled-job" } }),
        _vm._v(" "),
        _c("div", { staticClass: "admin-config-panel" }, [
          _c(
            "div",
            { staticClass: "admin-config-panel__inner" },
            [
              _c("div", { staticClass: "admin-linear-head" }, [
                _c("div", [
                  _c("span", { staticClass: "admin-linear-head__eyebrow" }, [
                    _vm._v("Maintenance"),
                  ]),
                  _vm._v(" "),
                  _c("h4", { staticClass: "admin-linear-head__title" }, [
                    _vm._v(_vm._s(_vm.trans("configuration.scheduled_job"))),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "admin-linear-head__description" }, [
                    _vm._v(
                      "Confirm the server cron command and review the jobs Laravel will run on schedule."
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _vm._m(0),
              ]),
              _vm._v(" "),
              _c("show-tip", {
                attrs: { module: "configuration", tip: "tip_scheduled_job" },
              }),
              _vm._v(" "),
              _c(
                "section",
                {
                  staticClass: "admin-config-section mt-3",
                  attrs: {
                    "aria-label": _vm.trans("configuration.scheduled_job"),
                  },
                },
                [
                  _c("div", { staticClass: "admin-linear-section-label" }, [
                    _vm._v("Scheduler command"),
                  ]),
                  _vm._v(" "),
                  _c("h4", { staticClass: "admin-config-section__title" }, [
                    _vm._v(_vm._s(_vm.trans("configuration.scheduled_job"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "p",
                    { staticClass: "admin-config-section__description" },
                    [
                      _vm._v(
                        "Server cron must call Laravel's scheduler so background tasks run at the expected time."
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _vm._m(2),
                ]
              ),
            ],
            1
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "admin-linear-stat" }, [
      _c("span", [_vm._v("Configured jobs")]),
      _vm._v(" "),
      _c("strong", [_vm._v("2")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "admin-linear-command-card mb-4" }, [
      _c("div", [
        _c("span", [_vm._v("Cron command")]),
        _vm._v(" "),
        _c("code", [
          _vm._v("php /path-to-artisan schedule:run >> /dev/null 2>&1"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "admin-list-table-card admin-config-list-card" },
      [
        _c("div", { staticClass: "table-responsive" }, [
          _c(
            "table",
            {
              staticClass:
                "table admin-data-table admin-data-table--config-list admin-linear-table mb-0",
            },
            [
              _c("thead", [
                _c("tr", [
                  _c("th", { attrs: { scope: "col" } }, [_vm._v("Action")]),
                  _vm._v(" "),
                  _c("th", { attrs: { scope: "col" } }, [_vm._v("Frequency")]),
                ]),
              ]),
              _vm._v(" "),
              _c("tbody", [
                _c("tr", [
                  _c("td", [
                    _c("strong", { staticClass: "admin-linear-primary" }, [
                      _vm._v("Birthday/Anniversary wish to Staff/Customer"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("span", { staticClass: "admin-linear-pill" }, [
                      _vm._v("Once per day at 09:00 AM"),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("td", [
                    _c("strong", { staticClass: "admin-linear-primary" }, [
                      _vm._v("Daily Backup"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("span", { staticClass: "admin-linear-pill" }, [
                      _vm._v("Once per day at 01:00 AM"),
                    ]),
                  ]),
                ]),
              ]),
            ]
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }